var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_vm._m(0),_c('div',{staticClass:"btn"},[_c('span',[_vm._v(_vm._s(_vm.pageNum))])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('span',[_vm._v("上一页")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('span',[_vm._v("下一页")])])
}]

export { render, staticRenderFns }